<template>
    <div class="w-full md:w-fit">
        <Button
            :disabled="attendanceData.attendance.cannotCancel"
            @click="show = true"
            color="danger-outline"
            size="small"
            iconName="close-circle"
            iconClass="w-4 h-4"
            class="w-full"
        >
            Cancel
        </Button>

        <ModalConfirmation
            :show="show"
            :action="submit"
            color="danger"
            title="Are you sure you want to cancel the meeting?"
            actionText="Yes, cancel"
            :actionProcessing="apiFormRef?.loading.valueOf()"
            @close="show = false"
        >
            <template #content>
                <div class="text-gray-500 text-center">
                    This action is irreversible.
                </div>
            </template>
        </ModalConfirmation>

        <ApiForm
            :url="
                urlFactory.makeMeetingAttendanceCancelUrl(
                    attendanceData.attendance.meetingId,
                    attendanceData.attendance.id,
                )
            "
            method="POST"
            :disableCatch="false"
            ref="apiFormRef"
        />
    </div>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import Button from '@/Shared/Component/Button.vue'
    import ModalConfirmation from '@/Shared/Component/ModalConfirmation.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import MeetingData from '@/App/Booking/Meeting/Entity/MeetingData'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import { ResponseJsonKeyEnum } from '@/Shared/AutoGenerated/Main'
    import ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
    import AttendanceData from '@/App/Booking/Attendance/Entity/AttendanceData'
    import Meeting from '@/App/Booking/Meeting/Entity/Meeting'

    const emits = defineEmits<{
        onSuccess: [{ meetingData: MeetingData }]
        onError: [{ errorMessage: string | null }]
    }>()

    const props = defineProps({
        meeting: {
            type: Object as PropType<Meeting>,
            required: true,
        },
        attendanceData: {
            type: Object as PropType<AttendanceData>,
            required: true,
        },
    })

    const show = ref(false)
    const apiFormRef = ref<ApiFormRefType>(null)

    const submit = () => {
        apiFormRef.value
            ?.submit()
            ?.then((response: ApiFormResponseType) => {
                show.value = false

                emits('onSuccess', {
                    meetingData: response.getHydratedMeetingData(
                        ResponseJsonKeyEnum.Meeting_Cancel_MeetingDataData,
                    ),
                })
            })
            ?.catch((response: ApiFormResponseType) => {
                show.value = false

                emits('onError', {
                    errorMessage: response.getMessage(),
                })
            })
    }
    const urlFactory = new UrlFactory()
</script>
